import { useAppContext } from '../../AppContext';
import { PanelHeader, PanelHeaderBack } from '@vkontakte/vkui';
import { APP_PLATFORM_TYPE_TELEGRAM } from '../../App';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

export const PlatformPanelHeader = (props) => {
  const context = useAppContext();

  if (context.platform === APP_PLATFORM_TYPE_TELEGRAM) {
    return (<HeaderTelegram {...props} />);
  }

  return (<HeaderVk {...props} />);
}

const HeaderTelegram = ({text = '', isShowBack = true, before = undefined}) => {
  const context = useAppContext();

  useEffect(() => {
    document.title = text;

    if (isShowBack) {
      context.getBridge().bridge.BackButton.show();
    } else {
      context.getBridge().bridge.BackButton.hide();
    }
  }, []);

  return (<></>);
}

const HeaderVk = ({text = '', isShowBack = true, before = undefined}) => {
  const context = useAppContext();

  const props = {};
  if (isShowBack) {
    props.before = (<PanelHeaderBack onClick={() => context.back()} />);
  } else if (before) {
    props.before = before;
  }

  return (<PanelHeader
    {...props}
    delimiter="none"
  >
    {text}
  </PanelHeader>);
}

PlatformPanelHeader.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isShowBack: PropTypes.bool,
  before: PropTypes.object,
};